import {
   CommentContext,
   CommentsByViewOptions,
   CommentsByViewResponse,
   CommentView,
} from './types';
import { makeRequest } from '../makeRequest';

export async function getCommentsByView(
   context: CommentContext,
   contextid: number,
   view: CommentView,
   { limit, offset, ...common }: CommentsByViewOptions = {}
): Promise<CommentsByViewResponse> {
   return makeRequest('get', `comments/${context}/${contextid}/${view}`, {
      ...common,
      query: {
         limit,
         offset,
      },
   });
}
